import { FC, memo } from 'react';

import { Icon } from '../Icon';
import { useTagBox } from './use-tag-box';

import styles from './styles.module.css';
import cx from 'clsx';

export const TagBox: FC = memo(() => {
  const { hashTag, handleCopy, handleShare, isCopied, isSticky, buttonRef } =
    useTagBox();

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <span className={styles.title}>
            Post your media using the hashtag below.
          </span>
          <span className={styles.description}>
            Tag us in your stories and follow us - you might get featured in our
            stories.{' '}
            <a href="https://www.instagram.com/playwall.kezerk" target="_blank">
              @playwall.kezerk
            </a>
          </span>

          <div className={styles.clipboardContainer}>
            <input
              name="hashTag"
              type="text"
              value={isCopied ? 'Copied to clipboard!' : hashTag}
              readOnly
              className={cx({
                [styles.clipboardInput]: true,
                [styles.clipboardInputCopied]: isCopied,
              })}
              onClick={handleCopy}
            />
            <Icon className={styles.iconFrame} name="frame" />
            <span className={styles.focusBg}></span>
          </div>

          <button
            ref={buttonRef}
            onClick={handleShare}
            className={cx(styles.button, {
              [styles.buttonSticky]: !isSticky,
              [styles.buttonNormal]: isSticky,
            })}
          >
            <span>Download & Share</span>
          </button>
        </div>
      </div>
    </>
  );
});
